/**
 * Guest session expiry channel.
 *
 * A guest's OTP session can lapse mid-session (typically 24h), and every
 * guest-authenticated call is made deep inside a tab component that has no way
 * to reach the share page's email gate. Rather than thread a callback through
 * every layer, the API client announces the expiry here and `ShareTokenPage`
 * listens: it reopens the gate and replays the action once verified.
 */

/**
 * Tabs a guest action can originate from — the report's interactive tabs, which
 * are exactly the ones the share page can replay after re-verification.
 */
export type GuestSessionTab = 'chat' | 'survey' | 'deck'

type Listener = (tab: GuestSessionTab) => void

const listeners = new Set<Listener>()

export function onGuestSessionExpired(listener: Listener): () => void {
  listeners.add(listener)
  return () => {
    listeners.delete(listener)
  }
}

export function notifyGuestSessionExpired(tab: GuestSessionTab = 'chat') {
  for (const listener of Array.from(listeners)) {
    listener(tab)
  }
}
